import React from "react";
import { useGlobalContext } from "../../context/cart_context";
import Cart from "../../asset/images/emptycart.jpg";
import CartItem from "../../components/Cart/CartItem";
import "../../App.css";
import QR from '../../asset/images/download.png'
import Miri from "../../asset/images/debit.png";
import { withStyles } from '@mui/styles';
import Camera from "../../asset/images/camera.png";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Card from '@mui/material/Card';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Master from "../../asset/images/mastercard.svg";
import QrReader from 'react-web-qr-reader';
import Popover from '@mui/material/Popover';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { Link, withRouter } from "react-router-dom";
import { alphabetSpaceOnly, maskNumber, numbersOnly } from '../../utils/common_function/common_function';
import QrScanner from "../qrscanner/qrscanner";
import DatePicker from "@mui/lab/DatePicker";
import TransactionApi from '../../utils/api/DepitTransaction';
import label from '../../utils/constant/label';
import Alert from "../Alert/alert";
import CircularProgress from '@mui/material/CircularProgress';
// import Alert from '@mui/material/Alert';
// import Stack from '@mui/material/Stack';

const delay = 500;

const previewStyle = {
  height: 180,
  width: 300,
};

const styles = {
  stepper: {
    padding: "30px 0px",
    "& .MuiStepLabel-alternativeLabel": {
      fontFamily: 'Noto Sans',
      color: "#212529 !important",


      "& .MuiSvgIcon-root.MuiStepIcon-root ": {
        width: "0.75em",
        height: "0.75em", color: "#ced4da"

      },

      "& .MuiStepIcon-root.Mui-active": {
        fontWeight: 600,
        color: "#f7941d"
      },

      "& .MuiStepIcon-root.Mui-completed ": {
        fontWeight: 600,
        color: "#f7941d"
      },


    },

    "& .MuiStep-alternativeLabel .MuiStepConnector-lineHorizontal": {
      border: "1px solid #92278F"
    }
  },

  paymentMethod: {
    display: "flex",
    border: "2px solid #ced4da",
    borderRadius: "0.5rem",
    margin: 5,
    width: 134,
    cursor: "pointer",
    "& input[type='radio']": {
      display: "none",
    },
    "& input[type='radio' i]:checked": {
      "& + div": {
        border: "2px solid #92278F",
        borderRadius: "0.5rem",
        margin: -2,
      },
    },
    // "& div":{
    //   color: "#6c757d",
    //   backgroundColor: "#f8f9fa",
    //   border: "solid 1px #dfe2e4",
    //   padding: "5px 12px",
    //   fontSize: 14,
    // }
  },

  imgPayment: {

    display: "flex",
    justifyContent: "flex-end",
    marginBottom: "15px !important",
    borderBottom: "1px solid #fff",
    "& img": {
      width: 70
    }
  },

  formControl: {
    display: "block",
    width: "100%",
    // padding: "0.75rem 0.75rem",
    fontSize: "1rem",
    fontWeight: 400,
    lineHeight: 1.5,
    color: "#fff",
    backgroundColor: "transparent",
    backgroundClip: "padding-box",
    border: "none",
    borderBottom: "1px solid #fff",
    appearance: "none",
    borderRadius: "0rem",
    transition: "border-color .15s ease-in-out,box-shadow .15s ease-in-out",
    marginTop: 10,
    "&:focus-visible": {
      outline: "none"
    }
  },

  textField: {

    "& div > input": {
      margin: "5px 0px"
    },

    "& div > div": {
      margin: "10px 0px"
    }
  },

  formCheck: {
    "& .MuiCheckbox-root.Mui-checked": {
      color: "#f7941d"
    },

    "& .MuiCheckbox-root": {
      paddingLeft: 0,
      paddingRight: 9,
      color: "#ced4da"
    }
  },

  header: {
    margin: "20px 0px"
  },

  card: {
    boxShadow: "0px 0px 10px #00000019 !important",
  },

  creditCard: {
    // background: " #FFF0FFB2 !important",
    // background: "linear-gradient(to right,  #f7941d,#92278F)",
    // background: "linear-gradient(to left, #92278F,#f7941d)",
    borderRadius: "0.75rem !important",
    // padding: 10,
    color: "#fff !important",
    //  minHeight: 220
  },

  selectMonth: {
    "& .MuiSelect-select": {
      color: "#fff !important"
    },

    "& .MuiSelect-icon": {
      color: "#fff !important"
    },
    "& .MuiInput-root:before": {
      borderBottom: "1px solid #fff !important"
    },

    "& .MuiInput-root:after": {
      borderBottom: "1px solid #fff !important"
    }
  },

  imgVerification: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    flex: 1,
    alignItems: "center",
    // flexWrap: "wrap",
    padding: 10,
    "& img": {
      width: 40,
      height: 40,
      // width:70, margin:20
    }
  },

  paymentcard: {
    border: "2px solid #ced4da",
    borderRadius: "0.5rem",
    margin: 5,
    cursor: "pointer",
    "& + .sampleSign": {
      display: "flex",
      justifyContent: "center",
      flexWrap: "wrap",
      paddingTop: 5,
    },

    //    "& .sampleSign":{
    //   display: "flex",
    //   justifyContent: "center",
    //   flexWrap: "wrap",
    //   paddingTop:5,
    // },

    "&:hover": {
      border: "2px solid #92278F",
    }

  },

  qrScan: {
    border: "2px solid #ced4da",
    borderRadius: "0.75rem",
    textAlign: "center",
    margin: "auto",
    padding: "19% 0%",
    cursor: "pointer",
    "& div": {
      display: "flex",
      justifyContent: "center"
    }
  },
  cvv: {

    width: "100%",
    paddingTop: "10px",
    paddingBottom: "10px",
    paddingLeft: "12px",
    "& div": {
      padding: 10,
      display: "flex",
      justifyContent: "center"
    }
  },

  camera: {
    height: 60,
    width: 60
  },

  borderOR: {
    width: 1,
    height: "32%",
    background: "#92278F",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  width: {
    marginLeft: "26%",
    marginTop: "17%"
  },
  clearIcon: {
    float: "right",
    cursor: "pointer",
    //marginRight: "10px",
    display: "flex",
    justifyContent: "center",
    zIndex: 2,
    position: "absolute",
    right: 5,
    margin: 8,
    borderRadius: 4,
    fontSize: 10,
    width: 20,
    height: 20,
    color: "#fff",
    alignItems: "center",
    background: "#212529",
  }
};

function CardDetails(props) {
  const [age, setAge] = React.useState('2023');
  const [isScanQrCode, setIsScanQrCode] = React.useState(null);
  const [token, setToken] = React.useState("");
  const [tokenError, setTokenError] = React.useState("");
  const [nameError, setNameError] = React.useState("");
  const [cvvError, setCvvError] = React.useState("");
  const [monthError, setMonthError] = React.useState("");
  const [name, setName] = React.useState("")
  const [lastName, setLastName] = React.useState("")
  const [lastNameError, setLastNameError] = React.useState("")
  const [month, setMonth] = React.useState(new Date())
  const [cvv, setCVV] = React.useState("")
  const [selectedCard, setSelectedCard] = React.useState("Card");
  const [message, setMessage] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [severity, setSeverity] = React.useState("");
  const [loader, setLoader] = React.useState(false);

  const steps = [
    'Payment',
    'Review & pay',
  ];
  const handleChange = (event) => {
    setMonth(event.target.value);
  };
  const handleYearChange = (event) => {
    setAge(event.target.value);
  };
  const handleScan = (result) => {

    if (result.data && result.data.length > 10) {
      var cardValue = ((result.data).split(","))
      if (cardValue.length >= 3) {
        setToken(cardValue[0])
        let name = cardValue[1].split(" ")
        setName(name[0])
        setLastName(name[1])
        setMonth(new Date(cardValue[2]))
        setCVV(cardValue[3])
        setNameError("")
        setLastNameError("")
        setCvvError("")
        setTokenError("")
      }


      setIsScanQrCode(false)
    }
    // if (result) {
    //     setResult(result);
    // }
  };

  const handleError = (error) => {
    console.log(error);
  };

  const scanQrCode = (e) => {
    setIsScanQrCode(e.currentTarget);

  }

  const requiredValidator = value => {
    if (!value || value.length <= 0) return 'Required';
    return '';
  };
  const toKenValidator = value => {
    if (!value || value.length <= 14) return 'Please enter valid Card';
    return '';
  };

  const handleClose = () => {
    setIsScanQrCode(null);
  };
  const onClickPayNow = () => {
    var isNameError = requiredValidator(name)
    var isLastNameError = requiredValidator(lastName)
    var isMontError = requiredValidator(month)
    var isCvvError = requiredValidator(cvv)
    var isTokenError = toKenValidator(token)

    if (isTokenError || isNameError || isLastNameError || isMontError || isCvvError) {
      setTokenError(isTokenError)
      setNameError(isNameError)
      setCvvError(isCvvError)
      setMonthError(isMontError)
      setLastNameError(isLastNameError)
    } else {

      let card = token
      // let trimValue = maskNumber(token, "X").replace(/ /g, "");
      // let setSpace = trimValue.match(/.{1,4}/g);
      // if (setSpace == null) {

      // } else {
      //   card = setSpace.join("-")
      //   // this.setState({ code: setSpace.join(" "), codeError: "" });
      // }
      let value = {}
      value.Amount =
        props.addToCart.reduce(function (accumulator, item) {
          return accumulator + item.TotalAmount;
        }, 0) +
        13 -
        10;
      value.pan = card
      value.firstName = name
      value.lastName = lastName
      value.cvv = cvv
      value.expDate = month
      value.ipAddress = ""
      value.cardType = selectedCard
      var data = new FormData();
      data.append("firstName", name)
      data.append("lastName", lastName)
      data.append("cvv", cvv)
      data.append("pan", card)
      data.append("expDate", month)
      data.append("ipAddress", '')
      setLoader(true)
      TransactionApi(data)
        .then((response) => {
          if (response.status === "S") {
            setLoader(false)
            console.log(response, "success")
            props.history.push({ pathname: "/SuccessTransact", state: { data: value } })  //response.data.data
          }
          else {
            setLoader(false)
            console.log(response.data.message, "error")
            setName('')
            setLastName('')
            setMonth(new Date())
            setCVV('')
            setToken('')
            setOpen(true)
            setMonthError('')
            setSeverity("error")
            setMessage(response.data.message)
          }
        })
        .catch((error) => {
          setLoader(false)
          setOpen(true)
          setSeverity("warning")
          setName('')
          setLastName('')
          setMonth('')
          setCVV('')
          setMonthError('')
          setToken('')
          setMessage(label.messages.apiError)
        })
    }
  }
  const onChangeCardName = (e) => {

    let trimValue = e.target.value.replace(/ /g, "");
    let setSpace = trimValue.match(/.{1,4}/g);
    if (setSpace == null) {
      setToken("")
    } else {
      setToken(setSpace.join(" "))
      // this.setState({ code: setSpace.join(" "), codeError: "" });
    }
    setTokenError("")
  };

  const onChangeName = (e) => {
    if (alphabetSpaceOnly(e.target.value)) {
      setName(e.target.value)
    }
    setNameError("")
  }
  const onChangeLastName = (e) => {
    if (alphabetSpaceOnly(e.target.value)) {
      setLastName(e.target.value)
    }
    setLastNameError("")
  }
  const onChangeCVV = (e) => {
    if (numbersOnly(e.target.value)) {
      setCVV(e.target.value)
    }
  }
  const onChange = (e) => {
    setSelectedCard(e.target.value);
  };

  const expDateFormatter = (expdate) => {
    return expdate.replace(/\//g, "").substring(0, 2) +
      (expdate.length > 2 ? '/' : '') +
      expdate.replace(/\//g, "").substring(2, 4);

  }

  const onChangeDate = (e) => {
    console.log("e", e)
    // expDateFormatter(e.target.value)

    setMonth(e)
    setMonthError("")
  }
  const onClose = () => {
    setOpen(false)
  }
  return (
    <>
      <Grid container>
        <Grid item xs={2} >
        </Grid>
        <Grid item xs={8}>
          <Stepper activeStep={1} alternativeLabel className={props.classes.stepper}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <Grid>
            <Card className={props.classes.card}>
              <div className="section section-center">
                <h1 className="cart-header d-flex justify-content-start">
                  Select Payment Method
                </h1>
                <Grid container>
                  <Grid item className={props.classes.payment}>
                    <Grid>
                      <label className={props.classes.paymentMethod}>
                        <input
                          type="radio"
                          name="radioname"
                          checked={selectedCard === "Card" ? true : false}
                          value="Card"
                          onChange={onChange}
                        />
                        <div className={props.classes.imgVerification}>
                          <img src={Miri} />
                          <span>Card</span>
                        </div>
                      </label>
                    </Grid>
                  </Grid>
                </Grid>
              </div>
            </Card>
          </Grid>
          <Card className={props.classes.card} style={{ marginTop: "1rem" }}>
            <div className="section section-center">
              <h1 className="cart-header d-flex justify-content-start">
                Enter Payment details
              </h1>


              <Grid container spacing={3}>
                <Grid item style={{ width: "48%" }}>
                  <div style={{ marginBottom: 10 }}>Enter card details</div>
                  <Card elevation={0} className={props.classes.creditCard}>
                    <Grid container >
                      <Grid container item xs={12} >
                        <Grid item xs={6} >
                          <FormControl style={{ width: "100%", paddingTop: 10 }}>
                            <TextField
                              label="First Name"
                              className={props.classes.textField}
                              // className={props.classes.formControl}
                              onChange={(e) => onChangeName(e)}
                              value={name}
                              error={nameError.length > 0}
                              helperText={nameError}
                              variant="standard"
                              inputProps={{ maxLength: 16 }} />
                          </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                          <FormControl style={{ width: "100%", paddingLeft: 10, paddingTop: 10 }} >
                            <TextField
                              label="Last Name"
                              className={props.classes.textField}
                              onChange={(e) => onChangeLastName(e)}
                              value={lastName}
                              error={lastNameError.length > 0}
                              helperText={lastNameError}
                              variant="standard"
                              inputProps={{ maxLength: 16 }} />
                          </FormControl>
                        </Grid>
                      </Grid>
                      <Grid container item xs={12} >
                        <FormControl style={{ width: "100%", marginTop: 10 }}>
                          <TextField
                            label="Card Number"
                            onChange={(e) => onChangeCardName(e)}
                            value={token}
                            variant="standard"
                            error={tokenError.length > 0}
                            helperText={tokenError}
                            inputProps={{ maxLength: 19 }} />
                        </FormControl>
                      </Grid>
                      <Grid item container xs={12}>
                        <Grid item xs={6}>
                          <FormControl style={{ width: "100%", paddingTop: 10 }}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>                              <DatePicker
                              label="Expiration Date"
                              views={["year", "month"]}
                              value={month}
                              minDate={new Date()}
                              inputFormat="MM/yyyy"
                              error={monthError?.length > 0}
                              helperText={monthError}
                              onChange={(e) => onChangeDate(e)}
                              mask="__/____"
                              disableMaskedInput={false}
                              renderInput={(params) => <TextField
                                variant="standard" {...params} />}
                            />
                            </LocalizationProvider>
                          </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                          <FormControl style={{ width: "100%", paddingTop: 10, paddingLeft: 10 }}  >
                            <TextField
                              label="CVC"
                              onChange={(e) => { setCVV(e.target.value); setCvvError("") }}
                              value={cvv}
                              variant="standard"
                              error={cvvError.length > 0}
                              helperText={cvvError}
                              inputProps={{ maxLength: 3 }} />

                          </FormControl>
                        </Grid>
                      </Grid>
                    </Grid>
                    {/* <Grid container>
                      <Grid item xs={12}>
                        <div className={props.classes.textField}>
                          <Grid container>
                            <Grid item xs={10}>
                              <input type="text" className={props.classes.formControl} id="floatingInput" onChange={(e) => onChangeCardName(e)} value={token} maxLength={19} />
                            </Grid>
                            <Grid item xs={2} className={props.classes.imgPayment}>
                              <img src={Master} />
                            </Grid>
                          </Grid>
                        </div>
                      </Grid>

                      <Grid item xs={12}>
                        <div className={props.classes.textField}>
                          <div class="d-flex">
                            <input type="text" className={props.classes.formControl} id="floatingInput" value={name} onChange={(e) => onChangeName(e)} />

                          </div>
                        </div>
                      </Grid>
                    </Grid> */}


                    {/* <Grid container spacing={2}>
                      <Grid item xs={4}>
                        <div className={props.classes.textField}>
                          <FormControl variant="standard" className={props.classes.selectMonth}>
                            <Select
                              inputProps={{ 'aria-label': 'Without label' }}
                              value={month}
                              onChange={handleChange}
                              displayEmpty
                            >
                              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((item) => {
                                return <MenuItem value={item}>{item}</MenuItem>
                              })}


                            </Select>
                          </FormControl>
                        </div>
                      </Grid>


                      <Grid item xs={4}>
                        <div className={props.classes.textField}>
                          <FormControl variant="standard" className={props.classes.selectMonth}>
                            <Select
                              inputProps={{ 'aria-label': 'Without label' }}
                              value={age}
                              onChange={handleYearChange}
                              displayEmpty
                            >
                              {[2023, 2024, 2025, 2026].map((item) => {
                                return <MenuItem value={item}>
                                  {item}</MenuItem>
                              })}

                            </Select>
                          </FormControl>
                        </div>
                      </Grid>

                      <Grid item xs={4} style={{ alignItems: "center", display: "flex" }}>
                        <Card className={props.classes.cvv}>
                          <input type="text" style={{ outline: "none", border: "none" }} value={cvv} onChange={onChangeCVV}></input>
                        </Card>
                      </Grid>
                    </Grid> */}

                  </Card>
                </Grid>

                <Grid item style={{
                  display: "flex", alignItems: "center", justifyContent: "center",
                  flexDirection: "column", width: "4%"
                }}>
                  <div className={props.classes.borderOR}></div>
                  <div style={{ padding: 20 }}>
                    OR
                  </div>
                  <div className={props.classes.borderOR}></div>
                </Grid>

                <Grid item style={{ width: "48%" }}>
                  <div style={{ marginBottom: 20 }}>Scan QR</div>

                  <div onClick={(e) => scanQrCode(e)} className={props.classes.qrScan}>
                    Click to scan
                    <div>
                      <img src={Camera} className={props.classes.camera} />
                    </div>
                  </div>

                </Grid>
              </Grid>



            </div>
            <QrScanner
              handleClose={handleClose}
              handleScan={handleScan}
              className={props.classes.width}
              handleError={handleError}
              open={isScanQrCode}
              camStyle={props.classes.qrScan}></QrScanner>
            {/* <Popover
              open={Boolean(isScanQrCode)}
              anchorEl={isScanQrCode}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
            >
              <div style={{ height: 300 }}>
                <div className={props.classes.clearIcon} onClick={handleClose}>
                  &#x2715;
                </div>
                {Boolean(isScanQrCode) &&
                  <QrReader
                    delay={delay}
                    style={previewStyle}
                    onError={handleError}
                    onScan={handleScan}
                  />
                }
              </div>
            </Popover> */}
          </Card>

          <Card className={props.classes.card} style={{ marginTop: "1rem" }}>
            <div className="section section-center">
              <h1 className="cart-header d-flex justify-content-start">
                ORDER SUMMARY
              </h1>
              <Grid container>
                {
                  props.addToCart.map((item) => {
                    return <CartItem key={item.id} prod={item} />;
                  })
                }

              </Grid>
            </div>
          </Card>

          <Grid container style={{ marginBottom: 20 }}>
            <Grid item xs={5}></Grid>
            <Grid item xs={2}>
              {/* <Link
                    to="/SuccessTransact"
                    className="link-btn"
                    style={{ marginTop: 20 }}

                  > */}
              <div className="link-btn" style={{ marginTop: 20, opacity: loader == true ? 0.5 : 1, cursor: loader == true ? "not-allowed" : "pointer" }} onClick={onClickPayNow}>
                {loader == true &&
                  <div style={{ width: '100%', height: '100%', textAlign: 'center' }} className="Loader" >
                    <CircularProgress style={{ width: "20px", height: "20px", position: "absolute" }} />
                  </div>
                }

                Pay Now
              </div>
              {/*on </Link> */}
            </Grid>
            <Grid item xs={5}></Grid>
          </Grid>
        </Grid>
        <Grid item xs={2}>
        </Grid>
      </Grid>
      <Alert message={message} open={open} severity={severity} onClose={onClose}></Alert>
    </>
  );
};

const mapStateToProps = (state) => ({
  addToCart: state.AddToCart.addToCart,

});

export default withStyles(styles)(
  withRouter(connect(mapStateToProps, null)(CardDetails))
);